export enum LimitTypeEnum { MERCADO = "MERCADO", LIMITE = "LIMITE" };

export enum ClientOrderStatusEnum {
  REGISTRO = "REGISTRO",
  COMPLEMENTACION = "COMPLEMENTACION",
  FIN = "FIN"
};

export enum ClientInstrumentValidationEnum {
  V1 = "V1",
  V2 = "V2",
  V3 = "V3",
  V4 = "V4",
};

export enum ClientOrderTypeEnum { COMPRA = "COMPRA", VENTA = "VENTA" };

export enum RentTypeEnum {
  RF = "RF",
  RV = "RV"
};

// Address structure from external API
export interface ClientAddress {
  recordId: number;
  fideicomitente: string;
  secuencia: number;
  ciudad: string;
  direccion: string;
  telefono: string;
  fax: string;
  tipo: string;
  observaciones: string;
  idCuentaInteligente: number;
}

// Client structure matching the external API response
export interface Client {
  codigoHomologado: string;
  tipoCliente: string;
  tipoIdentificacion: string;
  fideicomitente: string;
  ciu_ced: string;
  fechaExpedicion: string;
  titulo: string;
  nombre: string;
  autoretenedor: string;
  declarante: string;
  contribuyente: string;
  cod_Ciiu: string;
  fechaNacimiento: string;
  sexo: string;
  estadoCivil: string;
  codigo_Ciudad: string;
  cod_Empresa: number;
  relacion: string;
  email: string;
  especial: string;
  caracteristicas: string;
  celular: string;
  transaccionesInternet: number;
  digito: string;
  sipla: boolean;
  fechaIngreso: string;
  validacion: string;
  fechaActulizacion: string;
  ctaDeceval: string;
  cupoJuridico: number;
  fechaTran: string;
  ajuste: string;
  primerNombre: string;
  segundoNombre: string;
  primerApellido: string;
  segundoApellido: string;
  bloqueado: boolean;
  idBloqueo: number;
  red: number;
  activoSac: boolean;
  excentoenDividendos: number;
  generaVar: boolean;
  residenteColombia: boolean;
  paisdeResidencia: number;
  ingresos: number;
  clasificacionCliente: number;
  vigilado: number;
  vigiladoSfc: boolean;
  ficGpa: boolean;
  identificacion: string;
  exentoGmg: string;
  address: ClientAddress[];
}

export interface ClientInstrument {
  id: string;
  mnemonic: string;
  instrumentType: string;
  isin: string;
  currency: string;
  interestRate: string;
  frequency: string;
  issuanceDate: string;
  maturityDate: string;
  issuerName: string;
  rating: string;
  validation: string;
};

export interface ClientShareInstrument {
  id: string;
  mnemonic: string;
  isin: string;
  issuerName: string;
};

export interface ResponseClientInstruments {
  success: boolean;
  data?: ClientInstrument[];
  error?: string;
  message?: string;
}

export interface ClientRate {
  id: string;
  instrumentId: string;
  rate: number;
  price: number;
};

export interface ResponseClientRates {
  success: boolean;
  data?: ClientRate[];
  error?: string;
  message?: string;
}

export interface ClientOrderEntity {
  id: string;
  orderType: ClientOrderTypeEnum;
  rentType: RentTypeEnum;
  status: ClientOrderStatusEnum;
  instrument: ClientInstrument;
  client: Client;
  quantity: number;
  rate: number;
  limitType: LimitTypeEnum;
  limitPrice: number;
  value: number;
  createdAt: Date;
  updatedAt: Date | null;
  confirmNumber?: string;
}

export interface ClientOrderEntityKV {
  id: string;
  orderType: string;
  status: string;
  rentType: string; // "RF" (Renta Fija) or "RV" (Renta Variable)
  clientIdentification: string; // Client identification number
  clientIdentificationType: string; // Client identification type
  instrument: string;
  quantity: number;
  rate: number;
  value: number;
  createdAt: Date;
  updatedAt: Date | null;
  confirmNumber?: string;
  limitType: string;
  limitPrice: number;
}

export interface ClientOrderCreateRequest {
  clientIdentification: string; // Client identification number
  clientIdentificationType: string; // Client identification type (CC, NIT, etc)
  orderType: string;
  rentType: string; // "RF" or "RV"
  instrument: string;
  quantity: number;
  rate: number;
  value: number;
  status?: string;
  confirmNumber?: string;
  limitType: string;
  limitPrice: number;
}

export interface ClientOrderUpdateRequest {
  id: string;
  clientIdentification?: string;
  clientIdentificationType?: string;
  orderType?: string;
  rentType?: string; // "RF" or "RV"
  instrument?: string;
  quantity?: number;
  rate?: number;
  value?: number;
  status?: string;
  confirmNumber?: string;
  limitType?: string;
  limitPrice?: number;
}

export interface ResponseClientOrder {
  success: boolean;
  data?: ClientOrderEntity[];
  error?: string;
  message?: string;
}

export interface ResponseClientOrderKV {
  success: boolean;
  data?: ClientOrderEntityKV[];
  error?: string;
  message?: string;
}

export interface ResponseClients {
  success: boolean;
  data?: Client[];
  error?: string;
  message?: string;
}
